var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgRank3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "url(#paint0_radial_2560_12447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4998 79.4701C62.9164 79.4701 79.4673 62.9192 79.4673 42.5026C79.4673 22.0861 62.9164 5.53516 42.4998 5.53516C22.0832 5.53516 5.53235 22.0861 5.53235 42.5026C5.53235 62.9192 22.0832 79.4701 42.4998 79.4701Z",
    fill: "white",
    stroke: "url(#paint1_radial_2560_12447)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.692 49.4701L24.637 55.2007H61.6044L62.6561 48.2965C63.0066 45.9875 62.999 43.6327 62.6332 41.3237L61.5968 34.8462L51.5376 44.6157L43.1169 30.7539L33.6369 45.0958L24.637 35.5625L23.753 40.5311C23.2195 43.4879 23.1967 46.5133 23.692 49.4701Z",
    fill: "url(#paint2_linear_2560_12447)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0286 62.1406H27.2203C25.7952 62.1406 24.6445 60.9899 24.6445 59.5648V56.5547H61.612V59.5648C61.6044 60.9823 60.4537 62.1406 59.0286 62.1406Z",
    fill: "url(#paint3_linear_2560_12447)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.612 55.207H24.6445V56.5559H61.612V55.207Z",
    fill: "#FCD45E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6455 38.9384C26.9056 38.9384 28.7377 37.1062 28.7377 34.8462C28.7377 32.5861 26.9056 30.7539 24.6455 30.7539C22.3854 30.7539 20.5532 32.5861 20.5532 34.8462C20.5532 37.1062 22.3854 38.9384 24.6455 38.9384Z",
    fill: "url(#paint4_linear_2560_12447)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1248 33.454C45.3849 33.454 47.2171 31.6219 47.2171 29.3618C47.2171 27.1017 45.3849 25.2695 43.1248 25.2695C40.8648 25.2695 39.0326 27.1017 39.0326 29.3618C39.0326 31.6219 40.8648 33.454 43.1248 33.454Z",
    fill: "url(#paint5_linear_2560_12447)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6051 38.9384C63.8652 38.9384 65.6973 37.1062 65.6973 34.8462C65.6973 32.5861 63.8652 30.7539 61.6051 30.7539C59.345 30.7539 57.5128 32.5861 57.5128 34.8462C57.5128 37.1062 59.345 38.9384 61.6051 38.9384Z",
    fill: "url(#paint6_linear_2560_12447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2560_12447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9427 41.2474) scale(57.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2560_12447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4986 42.5014) scale(38.107)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2560_12447",
    x1: 43.1241,
    y1: 19.1049,
    x2: 43.1241,
    y2: 58.6817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2560_12447",
    x1: 42.9825,
    y1: 68.0471,
    x2: 43.1739,
    y2: 54.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2560_12447",
    x1: 31.5763,
    y1: 18.2035,
    x2: 29.1698,
    y2: 23.9791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2560_12447",
    x1: 45.3757,
    y1: 23.9559,
    x2: 42.9692,
    y2: 29.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2560_12447",
    x1: 63.072,
    y1: 31.3267,
    x2: 60.6655,
    y2: 37.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00602496,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#E9BD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRank3);
export default __webpack_public_path__ + "static/media/img_rank3.90439ae2bc6226967fa8419a3e56a817.svg";
export { ForwardRef as ReactComponent };